var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineUserTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/user-tick"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75A5.75 5.75 0 1117.75 7 5.757 5.757 0 0112 12.75zm0-10A4.25 4.25 0 1016.25 7 4.259 4.259 0 0012 2.75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M3.41 22.75a.755.755 0 01-.75-.75c0-4.27 4.19-7.75 9.34-7.75a10.894 10.894 0 012.96.4.747.747 0 11-.4 1.44 9.467 9.467 0 00-2.56-.34c-4.32 0-7.84 2.8-7.84 6.25a.755.755 0 01-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M18 22.75a4.721 4.721 0 01-4.06-2.31 4.612 4.612 0 01-.69-2.44 4.712 4.712 0 011.78-3.71A4.753 4.753 0 0122.75 18a4.672 4.672 0 01-.69 2.45 4.419 4.419 0 01-.95 1.12A4.593 4.593 0 0118 22.75zm0-8A3.266 3.266 0 0014.75 18a3.169 3.169 0 00.47 1.67A3.244 3.244 0 0018 21.25a3.192 3.192 0 002.13-.81 2.879 2.879 0 00.64-.76 3.148 3.148 0 00.48-1.68A3.256 3.256 0 0018 14.75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M17.429 19.74a.742.742 0 01-.53-.22l-.99-.99a.75.75 0 111.06-1.058l.48.48 1.6-1.48a.75.75 0 011.02 1.1l-2.13 1.97a.782.782 0 01-.51.198z"
  }))));
}
export default SvgVuesaxOutlineUserTick;